module.exports = __webpack_public_path__ + "static/media/project9.02ea21cb.png";